"use strict";
import Swiper from "swiper/bundle";

const mediaQueryList = window.matchMedia("(min-width: 768px)");


const sliders = document.querySelectorAll(".js-slider");
const slidersPc = document.querySelector(".js-slider-pc");
const thumbs = document.querySelectorAll(".js-thumb");
const contents = document.querySelectorAll(".js-cont");
const thumbClass = "js-thumb-item";
const thumbPc = document.querySelector(".js-thumb-pc");
const mytap = window.ontouchstart === null ? "touchstart" : "click";

/**
 * イベントリスナー
 */
const listener = (e) => {
  // リサイズ時に行う処理
  if (e.matches) {
    // 768px以上
    const sliderPc = new Swiper(".js-slider-pc", {
      effect: "fade",
      speed: 500,
      autoplay: {
        delay: 5500,
      },
      autoheight: true,
      pagination: {
        el: ".js-thumb-pc",
        type: "custom",
        renderCustom: function (swiper, current, total) {
          const slides = swiper.slides;
          let html = "";
          for (let i = 0; i < total; i++) {
            if (current == i + 1) {
              html =
                html +
                `<div class="specialist-environment-slider__thumb-fig ${thumbClass} is-current" id="current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
            }
            else {
              html =
                html +
                `<div class="specialist-environment-slider__thumb-fig ${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`;
            }
          }
          return html;
        },
      },
    });
    let clickThumbsPc = () => {
      let thumbItems = document.getElementsByClassName(thumbClass);
      let thumbActive = thumbPc.querySelector(".is-current");
      let thumbIndex = thumbActive.dataset.slideto;
      let thumbNum = Number(thumbIndex);
      let contShow = slidersPc.querySelector(".is-show");
      let contIndex = contShow.dataset.cont;

      for (let i = 0; i < contents.length; i++) {
        if (1 >= thumbNum) {
          if (contIndex !== "booth") {
            contShow.classList.remove("is-show");
            if (contents[i].dataset.cont === "booth") {
              contents[i].classList.add("is-show");
            }
          }
        } else if (3 >= thumbNum) {
          if (contIndex !== "council") {
            contShow.classList.remove("is-show");
            if (contents[i].dataset.cont === "council") {
              contents[i].classList.add("is-show");
            }
          }
        }
      }

      for (let i = 0; i < thumbItems.length; i++) {
        thumbItems[i].addEventListener(
          mytap,
          (e) => {
            let index = e.currentTarget.dataset.slideto;
            sliderPc.slideTo(index, 1000, true);
            // autoplayオプションを使わない場合は、以下をコメントアウトをする
            //setTimeout(sliderPc.autoplay.start, 1000);
          },
          false
        );
      }
    };
    sliderPc.on("slideChange", clickThumbsPc);
    clickThumbsPc();
  } else {
    // 768px未満

    for (let i = 0; i < sliders.length; i++) {
      sliders[i].className += i;
      thumbs[i].className += i;
      const slider = new Swiper(".js-slider" + i, {
        effect: "fade",
        speed: 500,
        autoplay: {
          delay: 5500,
        },
        pagination: {
          el: ".js-thumb" + i,
          type: "custom",
          renderCustom: function (swiper, current, total) {
            const slides = swiper.slides;
            let html = "";
            for (let i = 0; i < total; i++) {
              if (current == i + 1) {
                html =
                  html +
                  `<div class="specialist-environment-slider__thumb-fig ${thumbClass} is-current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
              }
              else {
                html =
                html +
                `<div class="specialist-environment-slider__thumb-fig ${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`;
            }
            }
            return html;
          },
        },
      });
      let clickThumbs = () => {
        let thumbItems = document.getElementsByClassName(thumbClass);
        for (let i = 0; i < thumbItems.length; i++) {
          thumbItems[i].addEventListener(
            mytap,
            (e) => {
              let index = e.currentTarget.dataset.slideto;
              slider.slideTo(index, 1000, true);
              // autoplayオプションを使わない場合は、以下をコメントアウトをする
              setTimeout(slider.autoplay.start, 5000);
            },
            false
          );
        }
      };
      slider.on("slideChange", clickThumbs);
      clickThumbs();
    }
  }
};

// リスナー登録
// mediaQueryList.addListener(listener); // @deprecated
mediaQueryList.addEventListener("change", listener);

// 初期化処理
listener(mediaQueryList);
